// client/src/components/marketer/project/modals/RecruitModal.js
import React, { useState } from 'react';
import { API_URL, PLATFORMS } from '../constants';
import AlertModal from './AlertModal';
import '../../../../styles/marketer/modals/RecruitModal.css';

export default function RecruitModal({ open, onClose, projectId, initialRecruit, onSaved }) {
  const [ctype, setCtype] = useState(initialRecruit?.contentType || '');
  const [plats, setPlats] = useState(initialRecruit?.platforms || []);
  const [saving, setSaving] = useState(false);
  const [alertMsg, setAlertMsg] = useState('');
  if (!open) return null;

  const togglePlat = (k) => setPlats(prev => prev.includes(k) ? prev.filter(x => x!==k) : [...prev, k]);

  const save = async () => {
    if (!projectId) { 
      setAlertMsg('먼저 1단계를 저장해주세요.'); 
      return; 
    }
    if (!['post','video','free'].includes(ctype)) { 
      setAlertMsg('콘텐츠 형식을 선택해주세요.'); 
      return; 
    }
    if (!plats.length) { 
      setAlertMsg('모집할 매체를 1개 이상 선택해주세요.'); 
      return; 
    }

    setSaving(true);
    try {
      const res = await fetch(`${API_URL}/api/marketer/mybiz/projects/${encodeURIComponent(projectId)}/recruit`, {
        method: 'PATCH', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ contentType: ctype, platforms: plats })
      });
      const j = await res.json().catch(()=>({}));
      if (!res.ok || !j?.ok) throw new Error(j?.message || '저장 실패');

      onSaved({ contentType: ctype, platforms: plats });
      onClose();
    } catch (e) { 
      setAlertMsg(e.message || '저장 실패'); 
    }
    setSaving(false);
  };

  const contentTypes = [
    { key: 'post', label: '글/사진 포스팅', icon: '📝', desc: '블로그, SNS 게시물 등' },
    { key: 'video', label: '동영상 콘텐츠', icon: '🎥', desc: '유튜브, 릴스, 숏폼 등' },
    { key: 'free', label: '자율 콘텐츠', icon: '✨', desc: '형식 제한 없음' }
  ];

  const platformIcons = {
    instagram: '📷',
    youtube: '▶️',
    blog: '📝',
    tiktok: '🎵',
    facebook: '👥',
    twitter: '🐦',
    etc: '⭐'
  };

  return (
    <>
      <div className="recruit-modal mbm-overlay">
        <div className="recruit-modal__content mbm">
          <button onClick={onClose} aria-label="close" className="recruit-modal__close mbm-close">×</button>

          <div className="recruit-modal__header">
            <div className="recruit-modal__title mbm-title">제품/장소/서비스를 광고할 SNS채널과, 광고 콘텐츠 형식을 선택해주세요.</div>
          </div>

          <div className="recruit-modal__body">
            {/* 콘텐츠 형식 선택 */}
            <div className="recruit-modal__section">
              <label className="recruit-modal__section-label">광고 콘텐츠 형식 (필수)</label>
              <div className="recruit-modal__content-types">
                {contentTypes.map(ct => (
                  <button
                    key={ct.key}
                    type="button"
                    onClick={() => setCtype(ct.key)}
                    className={`recruit-modal__content-card ${ctype === ct.key ? 'recruit-modal__content-card--selected' : ''}`}
                  >
                    <span className="recruit-modal__content-icon">{ct.icon}</span>
                    <div className="recruit-modal__content-info">
                      <span className="recruit-modal__content-label">{ct.label}</span>
                      <span className="recruit-modal__content-desc">{ct.desc}</span>
                    </div>
                    {ctype === ct.key && (
                      <span className="recruit-modal__check-icon">✓</span>
                    )}
                  </button>
                ))}
              </div>
            </div>

            {/* SNS 채널 선택 */}
            <div className="recruit-modal__section">
              <label className="recruit-modal__section-label">
                광고할 SNS 채널 (필수, 중복 선택 가능)
                {plats.length > 0 && (
                  <span className="recruit-modal__count-badge">{plats.length}개 선택됨</span>
                )}
              </label>
              <div className="recruit-modal__platforms">
                {PLATFORMS.map(p => (
                  <button
                    key={p.key}
                    type="button"
                    onClick={() => togglePlat(p.key)}
                    className={`recruit-modal__platform-card ${plats.includes(p.key) ? 'recruit-modal__platform-card--selected' : ''}`}
                  >
                    <span className="recruit-modal__platform-icon">{platformIcons[p.key] || '📱'}</span>
                    <span className="recruit-modal__platform-label">{p.label}</span>
                    {plats.includes(p.key) && (
                      <span className="recruit-modal__platform-check">✓</span>
                    )}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="recruit-modal__actions mbm-foot">
            <button
              type="button"
              onClick={onClose}
              disabled={saving}
              className="recruit-modal__button recruit-modal__button--cancel mb-btn mb-btn-secondary"
            >
              취소
            </button>
            <button
              type="button"
              onClick={save}
              disabled={saving}
              className="recruit-modal__button recruit-modal__button--submit mb-btn mb-btn-primary"
            >
              {saving ? '저장 중...' : '확인'}
            </button>
          </div>
        </div>
      </div>

      <AlertModal 
        open={!!alertMsg} 
        onClose={() => setAlertMsg('')} 
        message={alertMsg} 
      />
    </>
  );
}